<template>
  <div class="wrapper">
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
    <div class="content-wrapper">
      <HeaderRegistered />
      <main class="main">
        <section class="dashboard-section">
          <div class="holder-search">
            <p class="dashboard-text">
              Welcome back {{ fullName }}!
            </p>
          </div>
          <div class="holder-cards">
            <transition name="tray">
              <div v-if="show" class="card-item">
                <div class="card upper-card">
                  <div class="card-header">
                    <h5>
                      <span class="holder-cards-title">Cases</span>
                      <span v-if="dashboardCategories.newCasesAmount" class="holder-cards-subtitle"> + {{
                        dashboardCategories.newCasesAmount
                      }} new</span>
                    </h5>
                    <a id="dashboard_push_case" @click="$router.push({path: '/cases'})">
                      <BlackArrowRight14 />
                    </a>
                  </div>
                  <div class="card-body">
                    <span class="holder-cards-count">{{ dashboardCategories.casesAmount }}</span>
                  </div>
                  <div class="card-img">
                    <CaseIcon100 />
                  </div>
                  <div
                    v-if="hasPermission(['case_management'])"
                    id="disabled-create-case-button"
                    ref="disabledCreateCaseButton"
                    class="card-btn disabled-permission"
                  >
                    <button
                      id="dashboard_create_case"
                      @click="$router.push({path: '/create-case'})"
                    >
                      Create Case
                    </button>
                  </div>
                  <tooltip
                    v-if="$refs.disabledCreateCaseButton && !hasPermission(['case_management'])"
                    :target-ref="$refs.disabledCreateCaseButton"
                  >
                    <span>To access case creation - you need to have system permission - 'Case management'</span>
                  </tooltip>
                </div>
              </div>
            </transition>
            <transition name="tray">
              <div
                v-if="show"
                class="card-item"
              >
                <div class="card upper-card">
                  <div class="card-header">
                    <h5>
                      <span class="holder-cards-title">Users</span>
                      <span v-if="dashboardCategories.newEmployeesAmount" class="holder-cards-subtitle"> + {{
                        dashboardCategories.newEmployeesAmount
                      }} new</span>
                    </h5>
                    <a
                      v-if="hasPermission(['view_contacts'])"
                      id="dashboard_push_users"
                      @click="$router.push({path: '/team'})"
                    >
                      <BlackArrowRight14 />
                    </a>
                    <div v-else class="card-nav-disabled" />
                  </div>
                  <div class="card-body">
                    <span class="holder-cards-count">{{ dashboardCategories.employeesAmount || '0' }}</span>
                  </div>
                  <div class="card-img">
                    <WhiteUserIcon73 />
                  </div>
                  <div
                    v-if="hasPermission(['invite_users'])"
                    id="disabled-invite-button"
                    ref="disabledInviteButton"
                    class="card-btn disabled-permission"
                  >
                    <button
                      id="dashboard_invite_team"
                      @click="$router.push({path: `/invite-new-contact/invite-team`})"
                    >
                      Invite
                    </button>
                  </div>
                  <tooltip
                    v-if="$refs.disabledInviteButton && !hasPermission(['invite_users'])"
                    :target-ref="$refs.disabledInviteButton"
                  >
                    <span>To access invite users - you need to have 'Invite user's' permission</span>
                  </tooltip>
                </div>
              </div>
            </transition>
            <transition name="tray">
              <div
                v-if="show"
                class="card-item"
              >
                <div class="card upper-card">
                  <div class="card-header">
                    <h5>
                      <span class="holder-cards-title">Custodians</span>
                      <span
                        v-if="dashboardCategories.newClientsAmount"
                        class="holder-cards-subtitle"
                      > + {{ dashboardCategories.newClientsAmount }} new</span>
                    </h5>
                    <a
                      v-if="hasPermission(['view_contacts'])"
                      id="dashboard_push_clients"
                      @click="$router.push({path: '/management/custodians'})"
                    >
                      <BlackArrowRight14 />
                    </a>
                    <div v-else class="card-nav-disabled" />
                  </div>
                  <div class="card-body">
                    <p v-if="false">
                      Invite custodians to work in the case
                    </p>
                    <span class="holder-cards-count">{{ dashboardCategories.clientsAmount }}</span>
                  </div>
                  <div class="card-img">
                    <GreyUsersIcon100 />
                  </div>
                  <div class="card-btn" />
                </div>
              </div>
            </transition>
          </div>
          <div class="holder-status">
            <transition name="fade">
              <div v-if="show">
                <h6>System status</h6>
              </div>
            </transition>
            <div class="status-content">
              <transition name="tray">
                <div class="holder-status-content">
                  <ul class="status-info">
                    <li class="holder-status-item">
                      <div class="card">
                        <div class="card-header">
                          <h5>Active Cases</h5>
                          <span>{{
                            dashboardInfo.activeCasesAmount + " " + (dashboardInfo.activeCasesAmount === 1 ? "case" : "cases")
                          }}</span>
                        </div>
                        <div class="card-body">
                          <!--                          <div class="card-body-info">
                                                      <button id="dashboard_paid" class="btn paid">
                                                        paid
                                                      </button>
                                                      <div class="right-info">
                                                        <span class="last-pay">Last payment</span>
                                                        <span class="data-span">{{ dashboardInfo.lastCasePaymentDate }}</span>
                                                      </div>
                                                    </div>-->
                          <!--                          <span class="sum-info">$ {{ dashboardInfo.lastCasePaymentSum }}</span>
                                                    <span class="num-of-card">{{ dashboardInfo.lastCasePaymentCard }}</span>-->
                        </div>
                      </div>
                    </li>
                    <li class="holder-status-item">
                      <div class="card">
                        <div class="card-header">
                          <h5>Storage Status</h5>
                        </div>
                        <div class="card-body">
                          <h2 class="status-info-title accent">
                            {{ dashboardInfo.storageStatus || 0 }} GB
                          </h2>
                          <p>of files added in the last 24 hours</p>
                        </div>
                      </div>
                    </li>
                    <li class="holder-status-item">
                      <div class="card">
                        <div class="card-header">
                          <h5>New Members</h5>
                        </div>
                        <div class="card-body">
                          <h2 class="status-info-title accent">
                            {{
                              dashboardInfo.newMembersAmount + " " + (dashboardInfo.newMembersAmount === 1 ? "member" : "people")
                            }}
                          </h2>
                          <p>joined in the last 24 hours</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
          <div class="holder-status holder-status-detail">
            <transition name="fade">
              <div v-if="show">
                <h6>details</h6>
              </div>
            </transition>
            <div class="status-content">
              <div v-if="!isStatus" class="holder-status-img">
                <img src="@/assets/img/system-status.svg" alt="">
              </div>
              <transition name="tray">
                <div v-if="isStatus" class="holder-status-content">
                  <ul class="status-info">
                    <li class="holder-status-item w-33">
                      <div class="card">
                        <div class="card-header">
                          <h5>Reach by device</h5>
                        </div>
                        <div class="card-body">
                          <div class="holder-chart">
                            <PieCart
                              v-if="this.dashboardInfo.desktopReach && this.dashboardInfo.mobileReach"
                              :desktop-reach="dashboardInfo.desktopReach"
                              :mobile-reach="dashboardInfo.mobileReach"
                            />
                          </div>
                        </div>
                      </div>
                    </li>
                    <li class="holder-status-item w-33">
                      <div class="card">
                        <div class="card-header">
                          <h5>New Messages</h5>
                        </div>
                        <div class="card-body">
                          <ul>
                            <li
                              v-for="(item, index) in dashboardInfo.newMessagesCases.slice(0, 3)"
                              :key="index"
                              class="new-mass"
                              :item="item"
                            >
                              <h4>{{ item.caseName }}</h4>
                              <div
                                :id="`disabled-view-case-button_${index}`"
                                :ref="`disabled-view-case-button_${index}`"
                              >
                                <button
                                  :id="`dashboard_message_${index+1}`"
                                  :disabled="!item.hasViewPermission"
                                  class="btn btn-revert btn-case-message"
                                  @click="goToCaseMessages(item.caseId, item.caseName)"
                                >
                                  View
                                </button>
                              </div>
                              <tooltip
                                v-if="$refs[`disabled-view-case-button_${index}`] && !item.hasViewPermission"
                                :target-ref="$refs[`disabled-view-case-button_${index}`][0]"
                              >
                                <span>To access view case - you need to have 'view case' permission</span>
                              </tooltip>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                    <li class="holder-status-item w-33">
                      <div class="card">
                        <div class="card-header">
                          <h5 class="attention">
                            Damaged Files
                            <span class="last24">(last 24 hours)</span>
                          </h5>
                          <h2 class="status-info-title error-title">
                            {{ dashboardInfo.damagedFiles.length }} files
                          </h2>
                        </div>
                        <div class="card-body">
                          <!--                          <button class="btn gray-btn">Recover</button>-->
                          <CustomInputFile
                            v-for="(item, index) in dashboardInfo.damagedFiles"
                            :key="index"
                            :damaged-file="item"
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>

import hasPermission from '../utils/permission';
import HeaderRegistered from '../components/layout/HeaderRegistered';
import AlertErrorMsg from '../components/profile/AlertErrorMsg';
import PieCart from '../components/Charts/PieCart';
import CustomInputFile from '../components/inputs/CustomInputFile';
import Tooltip from '@/components/common/Tooltip.vue';
import errorHandler from '@/mixins/errorHandler';
import capitalizeFirstLetter from '@/mixins/capitalizeFirstLetter';
import BlackArrowRight14 from '@/components/icons/BlackArrowRight14.vue';
import CaseIcon100 from '@/components/icons/CaseIcon100.vue';
import WhiteUserIcon73 from '@/components/icons/WhiteUserIcon73.vue';
import GreyUsersIcon100 from '@/components/icons/GreyUsersIcon100.vue';

export default {
  name: 'Dashboard',
  components: {
    GreyUsersIcon100,
    WhiteUserIcon73,
    CaseIcon100,
    BlackArrowRight14,
    Tooltip,
    CustomInputFile,
    PieCart,
    HeaderRegistered,
    AlertErrorMsg,
  },
  mixins: [capitalizeFirstLetter, errorHandler],
  data() {
    return {
      completedSteps: 35,
      totalSteps: 100,
      accentColor: '#082655',
      warningColor: '#FF792E',
      dangerColor: '#F1105F',
      show: false,
      isStatus: true,
      userInfo: {},
      dashboardInfo: {
        activeCasesAmount: 0,
        damagedFiles: [],
        desktopReach: 0,
        mobileReach: 0,
        lastCasePaymentCard: 0,
        lastCasePaymentDate: '',
        lastCasePaymentSum: 0,
        newMembersAmount: 0,
        newMessagesCases: [],
        storageStatus: 0,
      },
      dashboardCategories: {
        casesAmount: 0,
        clientsAmount: 0,
        usersAmount: 0,
        newCasesAmount: 0,
        newClientsAmount: 0,
        newEmployeesAmount: 0,
      },
      errorMessage: '',
    };
  },
  computed: {
    fullName() {
      return this.userInfo.firstName && this.userInfo.lastName
        ? this.capitalizeFirstLetter(this.userInfo.firstName) + ' ' + this.capitalizeFirstLetter(this.userInfo.lastName)
        : '';
    },
    error() {
      return this.$store;
    }
  },
  async mounted() {
    this.show = true;
    await this.$load(async () => {
      const res = await this.$api.dashboard.getDashboardInfo();
      this.dashboardInfo = res.data.body;
      this.dashboardInfo.newMessagesCases = await Promise.all(
        this.dashboardInfo.newMessagesCases.slice(0, 3).map(async (item) => {
          return {
            ...item,
            hasViewPermission: await this.getCasePermissions(item.caseId),
          };
        }));
    }, (error) => {
      this.handleResponseError(error);
    });
    await this.$load(async () => {
      await this.$api.dashboard.getDashboardDamagedFiles().then((res) => {
        if (this.dashboardInfo.damagedFiles.length > 3) {
          this.dashboardInfo.damagedFiles = res.data.body.damagedFiles.slice(0, 3);
        } else {
          this.dashboardInfo.damagedFiles = res.data.body.damagedFiles;
        }
      }, (error) => {
        this.handleResponseError(error);
      });
    });
    await this.$load(async () => {
      await this.$api.dashboard.getDashboardCategories().then((res) => {
        this.dashboardCategories = res.data.body;
      }, (error) => {
        this.handleResponseError(error);
      });
    });
    await this.$load(async () => {
      await this.$api.profile.getProfile().then((res) => {
        this.userInfo = res.data.body;
      }, (error) => {
        this.handleResponseError(error);
      });
    });
  },
  methods: {
    hasPermission,
    beforeEnter: function (el) {
      el.style.opacity = el.style.transformOrigin = 'left';
    },
    goToCaseMessages(caseId, caseName) {
      localStorage.setItem('title', caseName);
      this.$router.push({path: `/cases/${caseId}/messages/chats`});
    },
    async getCasePermissions(caseId) {
      let hasViewPermission = false;
      const res = await this.$api.cases.getPermissionPerCase(caseId);
      if (res.data && res.data.body && res.data.body.permissions) {
        hasViewPermission = res.data.body.permissions.some(permission => permission === 'view_case');
      }
      return hasViewPermission;
    },
  },
};
</script>

<style scoped>

.dashboard-section {
  display: flex;
  flex-direction: column;
  background-color: var(--white-color);
  padding: 27px 55px 27px 35px;
}

.dashboard-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: var(--light-gray);
  margin: 0;
}

.holder-search {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 57px;
}

.search {
  border-radius: 79px;
  border: 1px solid var(--input-placeholder-value-color);
  padding: 9px 15px 9px 44px;
}

.dashboard-search {
  position: relative;
}

.search::placeholder {
  color: var(--input-placeholder-value-color);
  font-size: 14px;
}

.dashboard-search svg {
  position: absolute;
  top: 9px;
  left: 12px;
}

input {
  outline: none;
}

.holder-cards {
  display: flex;
  align-items: initial;
  justify-content: space-between;
  margin: 0 -15px;
}

.card-item {
  width: calc(33.33% - 48px);
  min-width: 330px;
  padding: 0 15px;
}

.card {
  display: flex;
  position: relative;
  -ms-flex-direction: column;
  flex-direction: column;
  border-radius: 10px;
  background-color: var(--white-color);
  overflow: hidden;
  min-height: 100%;
  padding: 23px 23px;
  transition: box-shadow 0.5s;
  box-shadow: 0px 4px 39px 0px #08265514;
}

.upper-card {
  padding: 0 0 23px 23px;
}

.card:hover {
  box-shadow: 0 4px 39px rgba(0, 0, 0, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header h5 {
  color: var(--secondary-black-color);
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.card-header a {
  padding: 25px 40px 25px 70px;
}

.card-header .card-nav-disabled {
  padding: 40px 40px 25px 70px;
}

.card-body {
  margin-bottom: 25px;
}

.card-body p {
  width: 60%;
  color: var(--light-gray);
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.card-img {
  position: absolute;
  bottom: -18px;
  right: 0;
}

.card-btn button {
  color: var(--accent-color);
  min-width: 120px;
  padding: 10px 20px;
  border-radius: 25px;
  border: 1px solid var(--accent-color);
  font-size: 14px;
  font-weight: 600;
  background-color: var(--white-color);
}

.holder-status-img {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* status content */
.holder-status-content {
  display: flex;
}

.status-info {
  display: flex;
  align-items: initial;
  width: 100%;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  /*justify-content: space-between;*/
}

.status-info .card-body {
  margin: 0;
}

.status-info p {
  color: var(--secondary-text-color);
}

.holder-status-item {
  /*width: calc(33.33% - 48px);*/
  width: 25%;
  padding: 0 15px;
  margin-bottom: 25px;
}

.holder-status-detail .holder-status-item:first-child {
  display: none;
}

.holder-status-detail .holder-status-item {
  width: 50%;
}

.btn-case-message {
  width: 335px;
}

.card-body-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.right-info {
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: flex-end;
}

.paid {
  min-width: 68px;
}

.last-pay {
  text-transform: uppercase;
  font-weight: 400;
  font-size: 10px;
  color: var(--light-gray);
  margin-bottom: 4px;
}

.data-span {
  display: block;
  font-weight: 500;
  font-size: 12px;
}

.sum-info {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: var(--accent-color);
  margin-bottom: 9px;
}

.num-of-card {
  font-weight: 400;
  font-size: 12px;
  color: var(--secondary-text-color);
}

.status-info-title {
  font-weight: 500;
  font-size: 14px;
}

.accent {
  color: var(--accent-color);
}

.w-33 {
  width: 33.33%;
}

.new-mass {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.new-mass h4 {
  font-weight: 500;
  font-size: 14px;
  margin-right: 40px;
  width: calc(100% - 335px);
}

.error-title {
  color: var(--error-color);
}

.holder-cards-subtitle {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--accent-color);
  display: inline-block;
  margin-left: 13px;
}

.holder-cards-count {
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 58px;
  color: #373C44;
}

.last24 {
  font-weight: 400;
  font-size: 16px;
  color: var(--light-gray);
}

</style>
